<template>
  <config-pro-plus-base
    class='opc-zone-bundle__main-add'
    :plan-details-label="$t('billing.plan_details')"
    :hide-comparison-table="true"
    :show-plan-details='showPlanDetails'>
    <template #config>
      <div class="opc-zone-bundle__main-add-title">
        <p class="label-title-1">
          {{ $t('billing.zone_pro_plus.select_local_number_title') }}
          <zm-tooltip
            slot="label-suffix"
            :content="$t('billing.zone.attendee_info')"
            aria-label="Learn more about numbers"
            placement="top"
          >
            <zm-button data-testid="checkout-button-122" ghost icon="zm-icon-info-outline main-color-icon" size="mini" type="icon"></zm-button>
          </zm-tooltip>
        </p>
        <p class="label-desc-1">
          <span>{{ $t('billing.zone_pro_plus.select_local_number_desc') }}</span>
        </p>
      </div>
      <template>
        <add-config :min-hosts="minHosts" v-if="boughtPbxBasePlan" />
        <config-plan :min-hosts="minHosts" :consider-time-base-coupon-with-base-plan="true" :monthly-disabled-alert-message="monthlyDisabledAlertMessage" v-else />
      </template>
    </template>
  </config-pro-plus-base>
</template>

<script type="text/jsx">
import ConfigProPlusBase from '@/plans/ZONE_PRO_PLUS/component/config-base';
import { mapGetters } from 'vuex';
import AddConfig from '@/plans/ZONE_PRO_PLUS/config/add-config.vue';
import ConfigPlan from '@/plans/ZONE_PRO_PLUS/config/config-plan';
import ConfigMixin from '@/plans/ZONE_PRO_PLUS/mixin/config-mixin';
import { editBasePlanWithPartnerMixin } from "@/views/config/partner-refer/mixin/edit-plan-with-partner";

export default {
  mixins: [ConfigMixin, editBasePlanWithPartnerMixin],
  components: { AddConfig, ConfigProPlusBase, ConfigPlan },
  computed: {
    ...mapGetters(['boughtPbxBasePlan', 'boughtPlans', 'sourcePlan']),
    minHosts() {
      return this.sourcePlan?.cartInfo?.selected_number || 1;
    },
    showPlanDetails() {
      // from pricing upgrade link
      if (this.$context.is.pro2prop) return false;
      return true;
    },
    monthlyDisabledAlertMessage() {
      return this.getCycleDisabledReasonForPartnerWithBasePlanUpgrade()?.reason;
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zone-bundle__main-add {
    &-title {
      margin-bottom: 8px;

      .label-title-1 {
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 8px;
      }

      .label-desc-1 {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
      }
    }

    .main-color-icon {
      font-size: 14px;
      color: $theme-color;
    }
}
</style>
